import { render } from "./StartingDashboard.vue?vue&type=template&id=64afb89c&scoped=true"
import script from "./StartingDashboard.vue?vue&type=script&lang=js"
export * from "./StartingDashboard.vue?vue&type=script&lang=js"

import "./StartingDashboard.vue?vue&type=style&index=0&id=64afb89c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64afb89c"]])

export default __exports__